export default {
	mounted() {
		/* eslint-disable */
		$(function () {
			$('[data-toggle="tooltip"]').tooltip();
		});
		/* eslint-enable */
	},
	updated() {
		/* eslint-disable */
		$(function () {
			$('[data-toggle="tooltip"]').tooltip();
		});
		/* eslint-enable */
	}
}